import React from 'react';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import border from 'scy/border.mod.scss';

export default function FilterItemContainer({ children }) {
  return (
    <div className={margin.bottom_sm}>
      <div
        className={`${margin.left_md} ${padding.bottom_sm} ${border.bottom}`}
      >
        {children}
      </div>
    </div>
  );
}
